import { render } from "./selectCofreHome.vue?vue&type=template&id=5abb3b66&scoped=true&ts=true"
import script from "./selectCofreHome.vue?vue&type=script&lang=ts"
export * from "./selectCofreHome.vue?vue&type=script&lang=ts"

import "./selectCofreHome.vue?vue&type=style&index=0&id=5abb3b66&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abb3b66"]])

export default __exports__